/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Plan_LoadInputs */

const en_platform_plan_load = /** @type {(inputs: Platform_Plan_LoadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kg`)
};

const pl_platform_plan_load = /** @type {(inputs: Platform_Plan_LoadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kg`)
};

/**
* | output |
* | --- |
* | "kg" |
*
* @param {Platform_Plan_LoadInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_plan_load = /** @type {((inputs?: Platform_Plan_LoadInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Plan_LoadInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_plan_load(inputs)
	return en_platform_plan_load(inputs)
});